import { type QuizQuestion, QuizQuestionType } from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { Type } from '@warp-drive/core/types/symbols';

import { SingleChoiceQuestionEditorComponent } from '../editors/question/choice-single.gts';
import { ReportingEditorComponent } from '../editors/reporting/reporting.gts';
import { SingleChoiceResponseEditorComponent } from '../editors/response/choice-single.gts';
import { SingleChoiceScoringEditorComponent } from '../editors/scoring/choice-single.gts';
import type { QuestionManager } from '../types/question-manager.ts';
import { DEFAULT_RESPONSE } from '../types/quiz-responses.ts';

export const SingleChoiceQuestionManager: QuestionManager = {
  discriminator: (question: QuizQuestion) =>
    question.type === QuizQuestionType.Choice &&
    (question.choice?.type === 'single' || !question.choice?.type),
  type: QuizQuestionType.Choice,
  icon: 'ph:radio-button',
  editingIcon: 'ph:radio-button-fill',
  editingLabel: 'Choices',
  label: 'Single Choice Question',
  questionComponent: SingleChoiceQuestionEditorComponent,
  scoringComponent: SingleChoiceScoringEditorComponent,
  responseComponent: SingleChoiceResponseEditorComponent,
  reportingComponent: ReportingEditorComponent,
  defaultData: {
    choice: {
      [Type]: DataTypeQuiz.QuizQuestionChoice,
      choices: [],
      type: 'single',
      scoring: 'individual',
      score: 0,
      category: '',
      additionalCategories: [],
      format: 'buttons',
      custom: false,
      picklist: '',
      response: DEFAULT_RESPONSE,
      response0: DEFAULT_RESPONSE,
    },
    reporting: {
      [Type]: DataTypeQuiz.QuizReportingQuestion,
      groupName: '',
      questionName: '',
    },
  },
};
